var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.833 10.875c.322 0 .597.11.825.33.228.22.342.484.342.795v7.875c0 .31-.114.576-.342.795-.228.22-.503.33-.825.33H6.167c-.322 0-.597-.11-.825-.33A1.065 1.065 0 0 1 5 19.875V12c0-.31.114-.576.342-.795.228-.22.503-.33.825-.33h1.166V7.5c0-.61.123-1.19.37-1.745a4.528 4.528 0 0 1 2.488-2.399A4.69 4.69 0 0 1 12 3a4.69 4.69 0 0 1 1.81.356 4.528 4.528 0 0 1 2.488 2.4c.246.553.369 1.135.369 1.744v3.375h1.166zM9.667 7.5v3.375h4.666V7.5a2.13 2.13 0 0 0-.683-1.59A2.29 2.29 0 0 0 12 5.25a2.29 2.29 0 0 0-1.65.66 2.13 2.13 0 0 0-.683 1.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.84b450343c17f1d7a188199db8df449a.svg";
export { ForwardRef as ReactComponent };